module.exports = __webpack_public_path__ + "img/日常维护.ec439741.svg";